<script>
export default {
  name: 'ConfirmLeave',

  methods: {
    handleCloseDialog () {
      this.$emit('close')
      this.$emit('update:dialogVisible', false)
    },
    submit () {
      this.$emit('submit')
    }
  }
}
</script>

<template lang="pug" src="./ConfirmLeave.pug"></template>
